<template>
  <div class="page-table">
    <div class="page-search">
      <a-form :form="searchForm" @submit="handleSearch">
        <a-row>
          <a-col :span="6">
            <a-form-item label="录入日期" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
              <a-range-picker style="width:100%;" @change="onpickerChange" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="校区" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
              <a-select
                  allowClear
                  v-decorator="['xqdm']"
                  placeholder="请选择"
                >
                <a-select-option
                v-for="schoolData in schoolData"
                :key="schoolData.value"
              >{{schoolData.label}}</a-select-option>
            </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="编码" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
              <a-input v-decorator="['bm']" placeholder="请输入编码" maxlength="10"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="名称" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
              <a-input v-decorator="['mc']" placeholder="请输入名称" maxlength="10"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="类别" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
              <a-input v-decorator="['lb']" placeholder="请输入类别" maxlength="10"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24" class="search-btns">
            <a-button style="margin-right:20px;" type="primary" html-type="submit">查询</a-button>
            <a-button type="primary" @click="exportExcel">导出</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
      <div class="table-operator">
        <standard-table style="margin-top:20px;border-top: 1px solid #e8e8e8;"
          :pagination="PAGINATION"
          :columns="columns"
          :dataSource="dataSource"
          @change="onChange"
          @rowChange="onRowChange"
        />
      </div>
    <!-- 弹框 -->
    <a-modal  style="margin-top:20px"
      destroyOnClose
      :maskClosable="false"
      :title="`${ current.id ? '编辑' : '新建' }用户`"
      v-model="visible"
      @ok="handleSubmit"
    >
      <a-form :form="form">
        <a-form-item label="用户名" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
          <a-input
            v-decorator="[
              'userName',
              {
                rules:[
                  { required: true,message: '请输入用户名！'},
                  { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]{2,10}$/, message: '2-10位汉字、字母或数字组成！' }
                ]
              }
            ]"
            placeholder="请输入"
            maxlength="10"
          />
        </a-form-item>
        <a-form-item label="密码" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
          <a-input
            v-decorator="[
              'password',
              {
                rules: [
                  { required: true, message: '请输入密码！' },
                  { pattern: /^[\s\S]{6,20}$/, message: '密码长度6～20位' }
                ]
              }
            ]"
            type="password"
            placeholder="请输入"
            maxlength="20"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
const env = process.env.NODE_ENV
export default {
  name: 'QueryList',
  data () {
    const columns = [
      {
        title: '校区',
        dataIndex: 'xq',
        align: 'center'
      },
      {
        title: '编码',
        dataIndex: 'bm',
        align: 'center'
      },
      {
        title: '名称',
        dataIndex: 'mc',
        align: 'center'
      },
      {
        title: '规格',
        dataIndex: 'gg',
        align: 'center'
      },
      {
        title: '单位',
        dataIndex: 'dw',
        align: 'center'
      },
      {
        title: '类别',
        dataIndex: 'lb',
        align: 'center'
      },
      {
        title: '仓库',
        dataIndex: 'ck',
        align: 'center'
      },
      {
        title: '使用总数',
        dataIndex: 'zs',
        align: 'center'
      }
    ]
    return {
      searchForm: this.$form.createForm(this),
      form: this.$form.createForm(this),
      columns,
      dataSource: [],
      selectedRows: [],
      visible: false,
      current: {},
      // 下拉
      schoolData: []
    }
  },
  mounted () {
    this.fetchList(this.getFetchParams())
    this.schoolList()
  },
  methods: {
    schoolList () {
      this.$axios.post('/api/dict/getXqInfo.do').then(res => {
        this.schoolData = res.data.data || []
      })
    },
    // 获取列表
    fetchList (params) {
      params.currentPageNo = params.pageNum
      this.$axios.post('/api/xtfx/hctj.do', params).then(res => {
        this.dataSource = res.rows || []
        // 处理分页情况
        const { pageNum, pageSize } = params
        this.PAGINATION = {
          total: res.total || 0,
          pageNum,
          pageSize
        }
      })
    },
    // 导出excel
    exportEx (params) {
      let url = env === 'production'
        ? '/xtfx/exportConsumables.do'
        : '/api/xtfx/exportConsumables.do'
      this.epxportway(url, params)
    },
    // 导出excel
    exportExcel (e) {
      e.preventDefault()
      this.exportEx(this.getParams())
    },
    // 导出方法
    epxportway (url, data) {
      if (url && data) {
        var form = window.$('<form></form>')
        form.attr('action', url)
        form.attr('method', 'post')
        for (var item in data) {
          var input = window.$('<input type="text" />')
          input.attr('name', item)
          input.attr('value', data[item])
          form.append(input)
        }
        form.appendTo('body').submit().remove()
      }
    },
    onpickerChange (date, dateString) {
      this.startTime = dateString[0]
      this.endTime = dateString[1]
    },
    // 搜索
    handleSearch (e) {
      e.preventDefault()
      this.fetchList(this.getFetchParams({ pageNum: 1 }))
    },
    onRowChange (selectedRows) {
      console.log(selectedRows)
      this.selectedRows = selectedRows
    },
    // 切换数据
    onChange (changeParams) {
      this.fetchList(this.getFetchParams(changeParams))
    },
    /**
     * 获取请求列表参数
     * @param { Object } customParam 自定义处理
     * @return { Object } 请求列表参数
     */
    getFetchParams (customParam) {
      const { pageNum, isRemove } = customParam || {}
      let params = {
        ...this.searchForm.getFieldsValue(),
        ...this.PAGINATION,
        ...customParam,
        startTime: this.startTime,
        endTime: this.endTime
      }
      if (pageNum && params.pageNum) {
        params.pageNum = pageNum
      } else {
        params.pageNum = 1
        params.pageSize = 10
      }
      if (isRemove && params.pageNum && this.dataSource.length % 10 === 1) {
        params.pageNum = params.pageNum > 2 ? params.pageNum - 1 : 1
      }
      // 用户类型
      params.type = '0'
      return params
    },
    getParams (custParam) {
      let params = {
        ...this.searchForm.getFieldsValue(),
        ...custParam,
        startTime: this.startTime,
        endTime: this.endTime
      }
      return params
    },
    // 显示弹框
    showModal (visible, record) {
      this.visible = !!visible
      this.current = record || {}
      // 编辑
      if (record) {
        this.$nextTick(() => {
          let fields = this.form.getFieldsValue()
          for (var key in fields) {
            fields[key] = record[key]
          }
          this.form.setFieldsValue(fields)
        })
      }
    },
    // 是否启用请求
    enableAjax (params) {
      this.$axios.post('/api/user/updateUserStatus', params).then(res => {
        this.$message.success(`成功${params.status === 1 ? ' 停用' : '启用'}！`)
        // 重新获取列表数据
        this.fetchList(this.getFetchParams())
      })
    },
    // 新增、编辑
    handleSubmit () {
      this.form.validateFields((err, values) => {
        if (!err) {
          // 处理编辑时添加ID字段
          if (JSON.stringify(this.current) !== '{}') {
            values.id = this.current.id
          }
          values.type = '0' // 0-前端 1-后端

          // 接口请求
          this.submitAjax(values)
        }
      })
    },
    // 新增、编辑请求
    submitAjax (params) {
      this.$axios.post('/api/user/addOrUpdateUser', params).then(res => {
        this.$message.success(`${params.id ? ' 编辑' : '新增'}成功！`)
        this.visible = false

        this.fetchList(this.getFetchParams({ pageNum: 1 }))
      })
    },
    // 删除
    handleRemove (record) {
      this.$confirm({
        title: '提示',
        content: '确定删除该条数据？',
        okType: 'danger',
        onOk: () => {
          // 删除请求
          this.removeAjax({ id: record.id })
        }
      })
    },
    // 删除请求
    removeAjax (params) {
      this.$axios.post('/api/user/deleteUser', params).then(res => {
        this.$message.success(`删除成功！`)

        this.fetchList(this.getFetchParams({ isRemove: true }))
      })
    }
  }
}
</script>
